/* eslint-disable import/prefer-default-export */
export enum LibraryTypeReference {
    FAQ = 'FAQ',
    Video = 'VIDEO',
    Documentation = 'DOCUMENTATION',
}
